export const trackingCategory = {
    publicNav: "Public Navigation",
    homepageHero: "Homepage Hero",
    homepageFooter: "Homepage Footer",
    athletesResultShare: "Athletes results share",
    sponsorIntegrationAtEvent: "Sponsor integration - Event level",
    signUpFlow: "Sign-up flow",
} as const;

export type TrackingCategory = typeof trackingCategory[keyof typeof trackingCategory];
type TrackClick = <E>(onClick?: (e: E) => void) => (label: string, category?: TrackingCategory | null) => (e: E) => void;

// Example of usage: onClick={trackClick(closeMenu)("Create new organisation", trackingCategory.publicNav)}
export const trackClick: TrackClick = onClick => (label, category = null) => e => {
    (window as any).dataLayer?.push({
        "event": "click_event",
        "event_label": label,
        "event_category": category,
    });
    return onClick && onClick(e);
};
